// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export function googleRedirectUri() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  return window.location.origin + "/auth/google";
}

export function startGoogleLogin() {
  const state = Math.random().toString(36).slice(2);
  sessionStorage.setItem("g_oauth_state", state);
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    redirect_uri: googleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    state,
    access_type: "online",
    prompt: "select_account",
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
